const HomePage = resolve => {
    require.ensure(["./components/HomePage.vue"], () => {
        resolve(require("./components/HomePage.vue"))
    })
}

export const routes = [
    {path: "/", component: HomePage}
]